"use client";

import { CheckCircle2Icon, Loader2Icon, XCircleIcon } from "lucide-react";
import { ToastBar, Toaster } from "react-hot-toast";

const CustomToaster = () => {
	return (
		<Toaster
			position="top-center"
			toastOptions={{
				success: {
					style: {
						background: "#005EFF",
						color: "white",
						fontWeight: 600,
						boxShadow: "none",
						padding: "12px 24px",
					},
				},
				loading: {
					style: {
						background: "#3b82f6",
						color: "white",
						fontWeight: 600,
						boxShadow: "none",
						padding: "12px 24px",
					},
				},
				error: {
					style: {
						background: "#ef4444",
						color: "white",
						fontWeight: 600,
						boxShadow: "none",
						padding: "12px 24px",
					},
				},
			}}
		>
			{(t) => (
				<ToastBar toast={t}>
					{({ message }) => (
						<div className="flex items-center justify-start gap-1">
							{t.type === "success" ? (
								<CheckCircle2Icon className="h-7 w-7 fill-white stroke-brand-primary" />
							) : t.type === "error" ? (
								<XCircleIcon className="h-7 w-7 fill-white stroke-red-500" />
							) : t.type === "loading" ? (
								<Loader2Icon className="h-7 w-7 animate-spin stroke-white" />
							) : null}
							<span>{message}</span>
						</div>
					)}
				</ToastBar>
			)}
		</Toaster>
	);
};

export default CustomToaster;
